import { InputFieldProps, SelectFieldProps } from "@/app/interface/components"
import React, { useCallback, useEffect, useRef, useState } from "react"
import styles from "@/styles/Fields.module.scss"

export const Input: React.FC<InputFieldProps> = ({ label, type, name, placeholder, value, onChange, isValid, errorMessage }) => {
    const [isFocused, setIsFocused] = useState(false)

    const handleFocus = () => setIsFocused(true)
    const handleBlur = () => setIsFocused(false)

    return (
        <div className={`${styles.inputLabel} ${(isFocused || value) ? styles.active : ''}${isValid ? '' : ' ' + styles.invalid}`}>
            <label htmlFor={name}>{label}</label>
            <input
                type={type}
                name={name}
                id={name}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                required
            />
            {!isValid && <span className={styles.invalid}>{errorMessage}</span>}
        </div>
    )
}

export const Select: React.FC<SelectFieldProps> = ({ ariaLabel, isValid, errorMessage, options, selectedValue, setSelectedValue, setState, resetValue }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const selectRef = useRef<HTMLDivElement>(null)

    const handleSelectToggle = useCallback(() => {
        setIsOpen(prev => !prev)
    }, [])

    const handleOptionSelect = useCallback((value: number | null) => {
        setSelectedValue(value, setState)
        setIsOpen(false)
        if(resetValue) resetValue(null, setState)
    }, [setSelectedValue, setState])

    const handleClickOutside = useCallback((event: MouseEvent) => {
        if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
            setIsOpen(false)
        }
    }, [])

    useEffect(() => {
        document.addEventListener('click', handleClickOutside)
        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [handleClickOutside])

    return (
        <div ref={selectRef} className={`${styles.inputLabel}${isValid ? '' : ' ' + styles.invalid}`}>
            <div className={styles.selectContent}>
                <div className={styles.selectWrapper}>
                    <button type="button" className={styles.wrapper} onClick={handleSelectToggle}>
                        <span className={styles.selectedValue}>
                            {options.find((opt: any) => opt.value === selectedValue)?.label || ariaLabel}
                        </span>
                        <span className="AZUL-AGRO">B</span>
                    </button>
                    {isOpen && (
                        <div className={styles.optionsContainer}>
                            <div className={styles.options}>
                                <button type="button" onClick={() => handleOptionSelect(null)}>
                                    {ariaLabel}
                                </button>
                                {options.map((opt: any, index: number) => (
                                    <button type="button" key={index} onClick={() => handleOptionSelect(opt.value)}>
                                        {opt.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {!isValid && <span className={styles.invalid}>{errorMessage}</span>}
        </div>
    )
}
